export default __webpack_public_path__ + "static/media/instagram.542ee68f.svg";